module.exports = __webpack_public_path__ + "img/img-01.0d6a4013.jpg";